import { Box } from "@mui/material";
import { CameraCard } from "./CameraCard.tsx";
import { gridStyleFor } from "./grid-layout.ts";
import type { GridLayout } from "../../store/flashbackStore/dashboardStore.ts";
import type { Camera } from "../../api/flashbackApi/types.ts";
import React from "react";

interface Props {
  cameras: Camera[];
  layout: GridLayout;
  onToggleStatus: (camera: Camera) => void;
  onOpenPlayback: (camera: Camera) => void;
}

export function CameraGrid({
  cameras,
  layout,
  onToggleStatus,
  onOpenPlayback,
}: Props): React.ReactElement {
  const { style: gridStyle, fillCells } = gridStyleFor(layout, cameras.length);

  return (
    <Box
      sx={{
        display: "grid",
        width: "100%",
        minHeight: 0,
        gap: 1,
        px: "8px",
        pb: 2,
        ...gridStyle,
      }}
    >
      {cameras.map((camera) => (
        <CameraCard
          key={camera.id}
          camera={camera}
          fillCell={fillCells}
          onToggleStatus={onToggleStatus}
          onOpenPlayback={onOpenPlayback}
        />
      ))}
    </Box>
  );
}
